/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CompressorForecastState,
  CompressorForecastState$inboundSchema,
  CompressorForecastState$Outbound,
  CompressorForecastState$outboundSchema,
} from "./compressorforecaststate.js";

/**
 * A single point-in-time in the MPC compressor schedule forecast
 */
export type CompressorScheduleStep = {
  /**
   * State per compressor, same order as the compressors array
   */
  states: Array<CompressorForecastState>;
  /**
   * ISO 8601 timestamp for this step
   */
  timestamp: Date;
};

/** @internal */
export const CompressorScheduleStep$inboundSchema: z.ZodType<
  CompressorScheduleStep,
  z.ZodTypeDef,
  unknown
> = z.object({
  states: z.array(CompressorForecastState$inboundSchema),
  timestamp: types.date(),
});
/** @internal */
export type CompressorScheduleStep$Outbound = {
  states: Array<CompressorForecastState$Outbound>;
  timestamp: string;
};

/** @internal */
export const CompressorScheduleStep$outboundSchema: z.ZodType<
  CompressorScheduleStep$Outbound,
  z.ZodTypeDef,
  CompressorScheduleStep
> = z.object({
  states: z.array(CompressorForecastState$outboundSchema),
  timestamp: z.date().transform(v => v.toISOString()),
});

export function compressorScheduleStepToJSON(
  compressorScheduleStep: CompressorScheduleStep,
): string {
  return JSON.stringify(
    CompressorScheduleStep$outboundSchema.parse(compressorScheduleStep),
  );
}
export function compressorScheduleStepFromJSON(
  jsonString: string,
): SafeParseResult<CompressorScheduleStep, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CompressorScheduleStep$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CompressorScheduleStep' from JSON`,
  );
}
